import { RootContainer } from '@gc-bridge/components/Container';
import { GcBridgeToolbar } from '@gc-bridge/components/Toolbar';
import { Outlet, RouteProps } from 'react-router';

export function Layout({ routesWithLayout }: { routesWithLayout: RouteProps[] }) {
  return (
    <RootContainer>
      <GcBridgeToolbar />

      <Outlet />
    </RootContainer>
  );
}
